import Auth from 'j-toker';
import { apiGet } from '../helpers/ApiHelper';
import * as notifications from './notificationActions';

export function organizeDocuments(documents) {
  const documentData = documents;
  let toDoActionItems = {};

  for (var index = 0; index < documentData.length; index++) {
    switch (documentData[index].document_type) {
      case 'Lease':
        arrayify('docType.lease', documentData[index]);
        break;
      case 'Renewal':
        arrayify('docType.renewal', documentData[index]);
        break;
      case 'Notice':
        arrayify('docType.notice', documentData[index]);
        break;
      case 'Inspection Report':
        arrayify('docType.inspection', documentData[index]);
        break;
      case 'Termination Agreement':
        arrayify('docType.terminationAgreement', documentData[index]);
        break;
      case 'Key Receipt':
        arrayify('docType.keyReceipt', documentData[index]);
        break;
      case 'Renters Insurance':
        arrayify('docType.rentersInsurance', documentData[index]);
        break;
      default:
        arrayify('docType.others', documentData[index]);
        break;
    }
  }

  const number_of_documents = documents.length;

  function arrayify(document_type, document) {
    if (typeof toDoActionItems[document_type] === 'undefined') {
      toDoActionItems[document_type] = [document];
    } else {
      toDoActionItems[document_type].push(document);
    }
  }

  return {
    type: 'ORGANIZE_DOCUMENTS',
    documents: toDoActionItems,
    numberOfDocuments: number_of_documents,
  };
}

export function getDocuments(translate) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/documents')
        .done(response => {
          dispatch(organizeDocuments(response, translate));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}
